export default __webpack_public_path__ + "static/media/map-mobile.fa5cb84b.png";